export default [
    {
      path: '/activity_a/building_rank/main',
      name: 'activity_a/building_rank/main',
      component: () => import(/* webpackChunkName: "activity_a" */ '../views/activity_a/building_rank/main')
    }
]